import {defaults, clone, keys, pick } from  'lodash/core'

export default class Model {

    constructor(datas) {
        defaults(this, datas, this.schema());
    }

    schema() {
        return {}
    }

    update(datas) {
        Object.assign(this, datas);
        return this
    }

    static build(datas, clone) {
        return datas.map((d) => {
            if(clone) return d.clone()
            return new this(d)
        })
    }

    static create(datas) {
        return new this(datas)
    }

    clone() {
        return clone(this)
    }

    toDatas()
    {
        var k = keys(this.schema());
        return pick(this, k);
    }


}

